export const GENERIC_DASHBOARD_MICROSERVICE_CLIENT_NAME = 'GenericDashboards';
export const WIDGETS_MICROSERVICE_CLIENT_NAME = 'Widgets';
export const PROTECTED_ENTITIES_MICROSERVICE_CLIENT_NAME = 'ProtectedEntities';

export enum GenericDashboardApiMethods {
  SET_SMART_VIEW_CATEGORY_STATUS = 'setSmartViewCategoryStatus',
  SET_WIDGET_CATEGORY_STATUS = 'setWidgetCategoryStatus',
  CHANGE_ACTIVE_VIEW = 'changeActiveView',
  UPDATE_VIEW = 'updateView',
  UPDATE_DASHBOARD_CONFIG_FOR_USER = 'updateDashboardConfigForUser',
  CREATE_VIEW = 'createView',
  DELETE_VIEW = 'deleteView',
  SET_SMART_VIEWS_PANEL_STATUS = 'setSmartViewsPanelStatus',
  COMPUTE_USER_CONFIG_FOR_DASHBOARD = 'computeUserConfigForDashboard',
  GET_COMPANIES = 'getCompanies',
  GET_COMPANIES_WITH_COUNT = 'getCompaniesWithCount',
  GET_WIDGETS_DATA_FOR_DASHBOARD = 'getWidgetsDataForDashboard',
}

export enum WidgetsApiMethods {
  GET_HEALTH_DASHBOARD_OVERVIEW = 'getHealthDashboardOverview',
}
